// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  SET_RCN,
  SET_MONTHLY_REPORTS,
  SET_PROTECTION_METRICS,
} from './types'

export const setMonthlyReports = data => ({
  type: SET_MONTHLY_REPORTS,
  ...data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setRcn = data => ({
  type: SET_RCN,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setProtectionMetrics = data => ({
  type: SET_PROTECTION_METRICS,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})
